module.exports = __webpack_public_path__ + "54ef400e0e0a8a5140181b3815638d00.mp4";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/cost_efficiency.mp4
// module id = 580
// module chunks = 0